module.exports = __webpack_public_path__ + "static/zjl.6c7accd827715d5c60d67e39419b2c19.jpg";